<template>
  <Popover v-model:show="PopoverShow">
    <div class="cancel_div" @click.stop="onSelect">
      <i class="iconfont icon-icon_wodeshoucang_quxiaoshoucangsvg" />
      <p class="cancel_text">{{ $t('cancel_favorite') }}</p>
    </div>
  </Popover>
  <i class="iconfont text_ellipsis icon-icon_shipin_gengduo1" @click.stop="openPopover" />
</template>

<script setup lang="ts">
import { Popover } from 'vant'
import { ref } from 'vue'

const emits = defineEmits(['cancel'])

const PopoverShow = ref(false)
const onSelect = () => {
  PopoverShow.value = false
  emits('cancel')
}

const openPopover = () => {
  PopoverShow.value = true
}
</script>

<style>
.van-popover__arrow {
  left: 88% !important;
}
</style>

<style scoped lang="less">
.cancel_div {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  .cancel_text {
    font-size: 14px;
    margin-left: 5px;
    color: #171921;
  }
}
.text_ellipsis {
  font-size: 18px;
  color: #999999;
}

</style>
